<template>
  <b-modal
    v-model="showTagsModal"
    :title="modalTitle"
    :body="modalBody"
    :item="item"
    centered
    hide-footer
    content-class="shadow"
    header-bg-variant="3v3"
    header-text-variant="light"
  >
    <div v-for="i in modalBody">
      <div class="info-modal d-flex">
        <!-- <p>{{ item[i] }}</p> -->
        <p>{{ i.title }} &nbsp;</p>
        <div v-if="i.format === 'date'">
          <div v-if="i.type == 'edit date'">
            <p v-if="item[i.key2]">
              Editado em {{ formatDate(item[i.key1]) }} por {{ item[i.key2] }}
            </p>
            <p v-else>Editado em {{ formatDate(item[i.key1]) }}</p>
          </div>
          <div v-else>
            <p>{{ formatDate(item[i.key]) }}</p>
          </div>
        </div>

        <div v-else>
          <p>{{ item[i.key] }}</p>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import moment from "moment";
export default {
  name: "SectorTagsModal",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    modalTitle: {
      type: String,
      required: true,
    },
    modalBody: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showTagsModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  created() {
    // console.log(this.modalBody);
  },

  watch: {
    showTagsModal(newValue, oldValue) {},
  },
  methods: {
    formatDate(data) {
      return moment(data).format("DD/MM/YYYY");
    },
  },
};
</script>
<style scoped></style>
